/**
 * The client half of the unified product version, surfaced in the UI (see ShellComponent).
 *
 * Kept in lock-step with the root package.json, checkins-client/package.json and
 * Checkins/Directory.Build.props by `npm run release` (commit-and-tag-version), via the
 * custom updater at scripts/ts-version-updater.js. Do not edit by hand — let a release bump it.
 */
export const appVersion = '1.2.0';
